import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty } from 'lodash';

@Pipe({ name: 'customCalendarContent' })
export class CustomCalendarCellContentPipe implements PipeTransform {
  /**
   * Pipe filters the list of rooms-chat based on the search text provided
   *
   * @returns list of rooms filtered by search text or []
   * @param events
   * @param type
   */
  transform(events: any, type: string): boolean {
    if (isEmpty(events)) return false;
    const filtered = events.find(
      (event: any) => event.customContentType === type
    );
    return filtered !== undefined;
  }
}
